import { useEffect, useRef } from "react";

const KONAMI_CODE = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];

export function useKonami(callback) {
  const sequence = useRef([]);
  useEffect(() => {
    const handler = (e) => {
      sequence.current.push(e.keyCode);
      if (sequence.current.length > KONAMI_CODE.length) sequence.current.shift();
      if (sequence.current.join(",") === KONAMI_CODE.join(",")) {
        callback();
        sequence.current = [];
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [callback]);
}
